import PropTypes from "prop-types";
import "./index.css";
import GaugeChart from "react-gauge-chart";

const LEVELS = ["freezing", "cold", "lukewarm", "warm", "hot", "fire"];

const LEVEL_PERCENT = {
  freezing: 1 / 12,
  cold: 3 / 12,
  lukewarm: 5 / 12,
  warm: 7 / 12,
  hot: 9 / 12,
  fire: 11 / 12,
};

const VIVID = ["#60a5fa", "#38bdf8", "#facc15", "#fb923c", "#f97316", "#ef4444"];

const PASTEL = ["#dbeafe", "#e0f2fe", "#fef9c3", "#ffedd5", "#fef2f2", "#fee2e2"];

export default function SentimentMeterCell({ getValue, row }) {
  const value = getValue()?.toLowerCase();
  const activeIndex = LEVELS.indexOf(value);
  const percent = LEVEL_PERCENT[value] ?? 0;
  const id = `sentiment-gauge-${row.index}`;

  if (!value || activeIndex === -1) return null;

  const colors = LEVELS.map((_, i) => (i <= activeIndex ? VIVID[i] : PASTEL[i]));

  return (
    <div className="sentiment-gauge-cell">
      <div className="sentiment-gauge-cell__chart">
        <GaugeChart
          id={id}
          nrOfLevels={6}
          colors={colors}
          percent={percent}
          hideText
          needleColor="#6b7280"
          needleBaseColor="#6b7280"
          animate={false}
          arcWidth={0.3}
          arcPadding={0.03}
          cornerRadius={2}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <span className="sentiment-gauge-cell__label">{value}</span>
    </div>
  );
}

SentimentMeterCell.propTypes = {
  getValue: PropTypes.func.isRequired,
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
  }).isRequired,
};
